<template>
  <div class="container-fluid px-0">
    <!-- Header -->
    <div class="row">
      <!-- Left Column - Donor Info -->
      <div class="col-lg-5 col-md-12">
        <!-- Profile Card -->
        <div class="row h-100">
          <div class="col-md-12">
            <div class="h-100">
              <div class="row">
                <div class="col-md-6">
                  <div
                    class="donor-avatar"
                    v-if="donorData.person && donorData.person.pictureUrl"
                  >
                    <img
                      :src="donorData.person.pictureUrl"
                      alt="Donor"
                      class="img-flui"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="text-muted s-13 mb-1">Name</div>
                  <div class="s-20 font-weight-600 text-black mb-2">
                    {{ donorData.person ? donorData.person.firstName : "" }}
                    {{ donorData.person ? donorData.person.lastName : "" }}
                  </div>

                  <div class="mb-2">
                    <div class="text-muted s-13">Email Address</div>
                    <div class="text-black">
                      {{ donorData.person ? donorData.person.email : "" }}
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="text-muted s-13">Phone Number</div>
                    <div class="text-black">
                      {{ donorData.person ? donorData.person.mobilePhone : "" }}
                    </div>
                  </div>

                  <div class="d-flex">
                    <el-button link @click="callDonor">
                      <PhoneIcon class="w-10 h-10 text-black" />
                    </el-button>
                    <el-button link @click="emailDonor">
                      <el-icon :size="18" class="text-black"
                        ><Message
                      /></el-icon>
                    </el-button>
                    <el-button link @click="whatsappDonor">
                      <WhatsappIcon class="w-10 h-10" />
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Total Given Card -->
          <div class="card border-0 rounded-lg total-given-card col-md-12 mt-2 p-3">
            <div
              class="card-body  text-white d-flex flex-wrap justify-content-between"
            >
              <div class="d-flex flex-column justify-content-between">
                <div>
                  <div class="fw-400 mb-1">Total Given</div>
                  <div class="h3 font-weight-600 mb-3">
                    {{
                      donorData.person &&
                      donorData.person.tenant &&
                      donorData.person.tenant.country &&
                      donorData.person.tenant.country.currencyObject &&
                      donorData.person.tenant.country.currencyObject
                        ? donorData.person.tenant.country.currencyObject.symbol
                        : ""
                    }}
                    {{
                      Math.round(donorData.totalGiving).toLocaleString() || ""
                    }}
                  </div>
                </div>
              </div>
              <div>
                <div>Online</div>
                <div class="font-weight-600">
                  {{
                    donorData.person &&
                    donorData.person.tenant &&
                    donorData.person.tenant.country &&
                    donorData.person.tenant.country.currencyObject &&
                    donorData.person.tenant.country.currencyObject
                      ? donorData.person.tenant.country.currencyObject.symbol
                      : ""
                  }}
                  {{
                    Math.round(
                      donorData.totalGivingOnline || 0
                    ).toLocaleString() || ""
                  }}
                </div>
                <div>In-church</div>
                <div class="font-weight-600">
                  {{
                    donorData.person &&
                    donorData.person.tenant &&
                    donorData.person.tenant.country &&
                    donorData.person.tenant.country.currencyObject &&
                    donorData.person.tenant.country.currencyObject
                      ? donorData.person.tenant.country.currencyObject.symbol
                      : ""
                  }}
                  {{
                    Math.round(
                      donorData.totalGivingInChurch || 0
                    ).toLocaleString() || ""
                  }}
                </div>
              </div>
            </div>
            <!-- <div class="d-flex align-items-center small">
              <div>
                <el-icon
                  :size="18"
                  :class="[
                    growthPercentage >= 0 ? 'text-green' : 'text-danger',
                  ]"
                  ><CaretTop
                /></el-icon>
              </div>
              <span
                :class="[growthPercentage >= 0 ? 'text-green' : 'text-danger']"
              >
                {{ Math.abs(growthPercentage) }}% vs previous year
              </span>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Right Column - Chart -->
      <div class="col-lg-7 col-md-12">
        <div class="card border-0 shadow-sm rounded-lg">
          <div class="card-body p-4">
            <div class="row mb-4">
              <div class="col-md-12">
                <div
                  class="d-flex justify-content-between align-items-center flex-wrap mb-4"
                >
                  <div class="d-flex align-items-center">
                    <div><PiggyBank class="w-14 h-14" /></div>
                    <div style="color: #0b3274" class="mb-0 s-20 fw-500">
                      Giving Trend
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="mr-3">
                      <el-button
                        link
                        class=""
                        :class="
                          activeTab === 'online'
                            ? 'primary--text font-weight-600'
                            : 'text-dak fw-400'
                        "
                        @click="activeTab = 'online'"
                      >
                        <span class="s-14">Online</span>
                      </el-button>
                      <el-button
                        link
                        class=""
                        :class="
                          activeTab === 'inchurch'
                            ? 'primary--text font-weight-600'
                            : 'text-dak fw-400'
                        "
                        @click="activeTab = 'inchurch'"
                      >
                        <span class="s-14">Inchurch</span>
                      </el-button>
                    </div>
                    <!-- <div
                        class="py-2 pl-4 primary--text s-15 bg-gray-500 fw-500"
                      >
                        <el-dropdown
                          trigger="click"
                          class="w-100"
                          @command="handleSortChange"
                        >
                          <span class="el-dropdown-link w-100">
                            <div
                              class="d-flex justify-content-between primary--text w-100"
                              size="large"
                            >
                              <span class="my-2"
                                >Sort By
                                {{
                                  sortBy && sortBy.name ? sortBy.name : sortBy
                                }}</span
                              >
                              <div class="bg-white d-flex py-1 my-1">
                                <el-icon class="el-icon--right">
                                  <arrow-down />
                                </el-icon>
                              </div>
                            </div>
                          </span>
                          <template #dropdown>
                            <el-dropdown-menu>
                              <el-dropdown-item
                                v-for="item in chartItemDropdown"
                                :key="item.value"
                                :command="item"
                              >
                                {{ item.name }}
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- Chart Container -->
            <div class="row">
              <div class="col-12">
                <div class="chart-container" id="element-to-print">
                  <TrendAreaChart
                    :data="trendAreaChartData"
                    :categories="monthLabels"
                    :height="250"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import PiggyBank from "../../../components/icons/PiggyBankIcon.vue";
import TrendAreaChart from "../../../components/charts/TrendAreaChart.vue";
import WhatsappIcon from "../../../components/icons/WhatsappIcon.vue";
import PhoneIcon from "../../../components/icons/PhoneIcon.vue";
const props = defineProps({
  donorData: { type: Object, required: true }, // single object for everything
});
// Reactive data
const activeTab = ref("inchurch");

const growthPercentage = ref(7);
const monthLabels = ref([
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]);
const trendAreaChartData = computed(() => {
  return props.donorData && props.donorData.monthlyGivingTrend
    ? props.donorData.monthlyGivingTrend.map((m) => m.amount)
    : [];
});

// Methods
// const formatCurrency = (amount) => {
//   return new Intl.NumberFormat("en-NG", {
//     style: "currency",
//     currency: "NGN",
//     minimumFractionDigits: 0,
//   }).format(amount);
// };

const callDonor = () => {
  if (
    props.donorData.value &&
    props.donorData.value.person &&
    props.donorData.value.person.mobilePhone
  ) {
    window.location.href = `tel:${props.donorData.value.person.mobilePhone}`;
  } else {
    return null;
  }
};

const emailDonor = () => {
  if (
    props.donorData.value &&
    props.donorData.value.person &&
    props.donorData.value.person.email
  ) {
    window.location.href = `mailto:${props.donorData.value.person.email}`;
  } else {
    return null;
  }
};

const whatsappDonor = () => {
  if (props.donorData.value && props.donorData.value.person) {
    const message = encodeURIComponent(
      `Hello ${props.donorData.value.person.lastName}, `
    );
    window.open(
      `https://wa.me/${props.donorData.value.person.mobilePhone.replace(
        /\D/g,
        ""
      )}?text=${message}`
    );
  } else {
    return null;
  }
};
</script>

<style scoped>
.text-green {
  color: #2cff2c !important;
}
/* Donor avatar styling */
.donor-avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: linear-gradient(135deg, #f97316 0%, #ea580c 100%); */
  /* border-radius: 12px; */
  /* overflow: hidden; */
}

.donor-avatar img {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  object-fit: cover;
}

/* Total given card styling */
.total-given-card {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  /* background: #ceddf6 !important; */
  border: 1px solid #b7b7b7 !important;
  /* background: #0040ff; */
}

/* Chart container styling */
.chart-container {
  background: white;
  border-radius: 8px;
  position: relative;
  height: 250px !important;
}

/* Rounded corners */
.rounded-lg {
  border-radius: 12px !important;
}

/* Element Plus dropdown styling */
:deep(.el-dropdown) {
  width: 100%;
}

:deep(.el-dropdown-menu) {
  border-radius: 8px;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: 1px solid rgba(0, 0, 0, 0.15);
}

:deep(.el-dropdown-menu__item) {
  padding: 8px 16px;
  font-size: 14px;
  color: #495057;
}

:deep(.el-dropdown-menu__item:hover) {
  background-color: #f8f9fa;
  color: #0745af;
}

@media (max-width: 575.98px) {
  .chart-container {
    height: 250px !important;
  }
}

/* Print styles */
@media print {
  .btn,
  .dropdown {
    display: none !important;
  }

  .card {
    border: 1px solid #dee2e6 !important;
    box-shadow: none !important;
  }
}
</style>
